// One place for the business identity that the legal pages, the contact page
// and payment-provider onboarding all quote. Razorpay's activation review reads
// these off your live site, so keep them true and reachable.
export const COMPANY = {
    name: "Tales with Terry",
    // Unregistered sole proprietorship: the legal identity is the person, so
    // Indian disclosure norms want the individual named alongside the brand.
    legalName: "Tales with Terry, a sole proprietorship of Vansh Malhotra",
    email: "vanshmalhotra353@gmail.com",
    phone: "+91 99253 51328",
    // City and state only. This ships in the JS bundle, so anything written here
    // is public — the full postal address goes to Razorpay's onboarding form and
    // to customers on their invoice, not onto the website.
    address: "Ahmedabad, Gujarat, India",
    hours: "Monday to Friday, 10am–6pm IST",
    // Bump when you change the policies. Shown at the top of each one.
    updated: "29 August 2026",
};
